export class TokenPasswordChange {
    public readonly password: string;
    public readonly passwordChangeToken: string;

    constructor(password: string, passwordChangeToken: string) {
        this.password = password;
        this.passwordChangeToken = passwordChangeToken;
    }
}
